let key = {};
if (process.env.REACT_APP_MODE == "production") {
  console.log("Set Production Config");
  const API_URL = "https://api.miraclebot.online";

  key = {
    secretOrKey: "vOVH6sdmpNWjRRIqCc7rdxs01lwHzfr3",
    CRYPTO_SECRET_KEY: "1234567812345678",
    // RECAPTCHA_SITE_KEY: "6LfBAlcgAAAAAIeo-0Q2m2gh35MnNt7GDfbOaz2o", //local
    REFERRAL_CODE: "DCA1234",
    RECAPTCHA_SITE_KEY: "6LeZE38iAAAAAJELdMKs5UMOycTRcmUpOHKlrGPx", //local secret_Key: 6LeZE38iAAAAANVOgrzpnv8I63UDHtGFO8NiigB8
    API_URL: "https://api.miraclebot.online",

    SOCKET_TICKERBINANCE_URL: `https://binanceapi.miraclebot.online`,
    SOCKET_TICKERBITMART_URL: `https://stagingbitmart.wearedev.team`,
    SOCKET_TICKERKUCOIN_URL: `https://stagingkucoin.wearedev.team`,
    FRONT_URL: "https://www.miraclebot.online",
    ADMIN_URL: "https://controls.miraclebot.online",
    SOCKET_URL: "https://api.miraclebot.online",
    getGeoInfo: "https://ipapi.co/json/",
    ipBind: "198.244.215.81",

    AUTHENTICATOR_URL: {
      PLAY_STORE:
        "https://play.google.com/store/apps/details?id=com.google.android.apps.authenticator2",
      APP_STORE:
        "https://apps.apple.com/us/app/google-authenticator/id388497605",
    },
  };
} 
else if (process.env.REACT_APP_MODE == "demo") {
  console.log("Set demo Config");
  const API_URL = "https://dopaminetradingbot.wearedev.team";

  key = {
    secretOrKey: "vOVH6sdmpNWjRRIqCc7rdxs01lwHzfr3",
    CRYPTO_SECRET_KEY: "1234567812345678",
    // RECAPTCHA_SITE_KEY: "6LfBAlcgAAAAAIeo-0Q2m2gh35MnNt7GDfbOaz2o", //local
    REFERRAL_CODE: "DCA1234",
    RECAPTCHA_SITE_KEY: "6LeZE38iAAAAAJELdMKs5UMOycTRcmUpOHKlrGPx", //local secret_Key: 6LeZE38iAAAAANVOgrzpnv8I63UDHtGFO8NiigB8
    API_URL: "https://dopaminetradingbot.wearedev.team",

    SOCKET_TICKERBINANCE_URL: `https://dopaminetradingbotbinance.wearedev.team`,
    SOCKET_TICKERBITMART_URL: `https://stagingbitmart.wearedev.team`,
    SOCKET_TICKERKUCOIN_URL: `https://stagingkucoin.wearedev.team`,
    FRONT_URL: "https://dopaminetradingbot-frontend-2025.pages.dev",
    ADMIN_URL: "https://dopaminetradingbot-adminpanel-2025.pages.dev",
    SOCKET_URL: "https://dopaminetradingbot.wearedev.team",
    getGeoInfo: "https://ipapi.co/json/",
    ipBind: "148.113.6.215",

    AUTHENTICATOR_URL: {
      PLAY_STORE:
        "https://play.google.com/store/apps/details?id=com.google.android.apps.authenticator2",
      APP_STORE:
        "https://apps.apple.com/us/app/google-authenticator/id388497605",
    },
  };
} else {
  console.log("Set Development Config");
  const API_URL = "http://127.0.0.1"; // 'http://localhost' 'http://192.168.0.124';  //http://192.168.29.63:3000/  http://192.168.0.124
  key = {
    secretOrKey: "vOVH6sdmpNWjRRIqCc7rdxs01lwHzfr3",
    CRYPTO_SECRET_KEY: "1234567812345678",
    RECAPTCHA_SITE_KEY: "6LeHezUfAAAAAE_uuY_HFN5HoEVsQv8bpyC3xTat", //local
    REFERRAL_CODE: "DCA1234",
    API_URL: `${API_URL}:2053`,
    FRONT_URL: "http://localhost:3000", //'http://localhost:3000',
    ADMIN_URL: "http://localhost:3001/admin",
    SOCKET_URL: `${API_URL}:2053`,
    SOCKET_TICKERBINANCE_URL: `${API_URL}:2055`,
    SOCKET_TICKERBITMART_URL: `${API_URL}:2056`,
    SOCKET_TICKERKUCOIN_URL: `${API_URL}:2057`,
    ipBind: "172.105.40.100",
    getGeoInfo: "https://ipapi.co/json/",
    AUTHENTICATOR_URL: {
      PLAY_STORE:
        "https://play.google.com/store/apps/details?id=com.google.android.apps.authenticator2",
      APP_STORE:
        "https://apps.apple.com/us/app/google-authenticator/id388497605",
    },
  };
}

export default {
  ...key,
  ...{ SITE_DETAIL: require("./siteConfig").default },
};
